import React, { useState } from 'react'
import styled from 'styled-components'
import { Select } from '../../Select'
import { TextAutoComplete } from '../../TextAutoComplete'
import { useFormContext } from 'react-hook-form'
import { CategorySkillOption } from '../../WorkPreference/Registration/ThirdForm/types'
import { FormErrorMessage } from '../../FormErrorMessage'
import { SkillFormItemProps } from './types'

const FormWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`

const SelectWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 8px;
  flex-direction: column;

  @media ${props => props.theme.media.sm} {
    flex-direction: row;
  }
`

const StyledSkillInput = styled.div`
  flex-grow: 1;
`

const StyledYearSelectContainer = styled.div`
  width: 100%;

  @media ${props => props.theme.media.sm} {
    max-width: 160px;
  }
`

const AddButtonContainer = styled.div`
  align-self: flex-end;
  padding: 9px 0;
`

const AddButton = styled.button`
  padding: 8px 16px;
  width: 100px;
  background-color: ${props => props.theme.members.colors.white};
  color: #06AA6A;
  border-radius: 40px;
  cursor: pointer;
  font-weight: 700;
  font-size: 12px;
  line-height: 1;
`

const yearOptions = [
  { value: '', label: '経験年数' },
  { value: 0, label: '1年未満' },
  { value: 1, label: '1年以上' },
  { value: 2, label: '2年以上' },
  { value: 3, label: '3年以上' },
  { value: 4, label: '4年以上' },
  { value: 5, label: '5年以上' },
  { value: 6, label: '6年以上' },
  { value: 7, label: '7年以上' },
  { value: 8, label: '8年以上' },
  { value: 9, label: '9年以上' },
  { value: 10, label: '10年以上' }
]

export const StyledSkillFormItem: React.FC<SkillFormItemProps> = (props: SkillFormItemProps) => {
  const { setValue, getValues } = useFormContext()
  const [selectedSkill, setSelectedSkill] = useState< CategorySkillOption | null >(null)
  const [selectedYears, setSelectedYears] = useState< number | '' >('')

  const currentSkills = getValues(`categorizedSkills.${props.categoryId}`) || []

  const handleAddSkill = () => {
    if (!selectedSkill) {
      alert('選択可能なスキルを選んでください')
      return
    }

    const isDuplicateCheck = currentSkills.some(
      field => field.masterSkillId === selectedSkill.value
    )

    if (isDuplicateCheck) {
      alert('既に登録済みのスキルです')
      return
    }

    setValue(`categorizedSkills.${props.categoryId}`, [
      {
        categoryId: props.categoryId,
        masterSkillId: selectedSkill.value,
        year: typeof selectedYears === 'number' ? selectedYears : '',
        name: selectedSkill.label,
        isFocusSkill: false
      },
      ...currentSkills
    ])

    setSelectedSkill(null)
    setSelectedYears('')
  }

  const hasError = props.errorMessages && props.errorMessages.length > 0

  return (
    <div className="mb-M">
      <FormWrapper>
        <SelectWrapper>
          <StyledSkillInput data-cy="skill-input">
            <TextAutoComplete
              inputSize="small"
              placeholder='スキル入力'
              onChange={setSelectedSkill}
              categoryId={props.categoryId}
              skillOption={props.skillOption}
              disabled={hasError}
            />
          </StyledSkillInput>
          <StyledYearSelectContainer data-cy="select-year">
            <Select
              inputSize="small"
              id={props.categoryName}
              name={props.categoryName}
              onChange={(e) => {
                const value = e.target.value;
                setSelectedYears(value === '' ? null : Number(value));
              }}
              value={selectedYears ?? ''}
              options={yearOptions}
              placeholder='経験年数'
              disabled={hasError}
            />
          </StyledYearSelectContainer>
        </SelectWrapper>
        <AddButtonContainer>
          <AddButton className="border-1 border-member-green-100 disabled:border-member-gray-40 disabled:bg-member-gray-30 disabled:text-member-black-100 disabled:opacity-70 disabled:cursor-not-allowed"
           type="button" onClick={handleAddSkill} disabled={hasError} data-cy="add-skill">
            追加
          </AddButton>
        </AddButtonContainer>
      </FormWrapper>
      {props.errorMessages && props.errorMessages.map(errorMessage => [
        <FormErrorMessage key={errorMessage} message={errorMessage} />
      ])}
    </div>
  )
}

